import { createFileRoute } from '@tanstack/react-router';

import { loadBillingMessages } from '@/modules/billing/route';
import { loadDashboardMessages } from '@/modules/dashboard/route';
import { loadWalletDashboardMessages, loadWalletDashboardScreens, walletDashboardScreen } from '@/modules/wallet-dashboard/route';
import { lazyScreen } from '@/shared/screen/lazy-screen';

// `/gestao-carteira/dashboard` (router.tsx:1349-1353). Carrega também os catálogos da Nova cobrança e da importação
// CNAB (Cobranças) e do popup de período (Dashboard), que a tela abre por cima.
export const Route = createFileRoute('/_app/gestao-carteira/dashboard/')({
  staticData: { screen: walletDashboardScreen },
  loader: () => Promise.all([loadWalletDashboardMessages(), loadBillingMessages(), loadDashboardMessages()]),
  component: lazyScreen(loadWalletDashboardScreens, 'WalletDashboardRouteScreen'),
});
